import { render, staticRenderFns } from "./Fidelidade.vue?vue&type=template&id=08efd1f7&scoped=true"
import script from "./Fidelidade.vue?vue&type=script&lang=js"
export * from "./Fidelidade.vue?vue&type=script&lang=js"
import style0 from "./Fidelidade.vue?vue&type=style&index=0&id=08efd1f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efd1f7",
  null
  
)

export default component.exports